import { useEffect, useState } from 'react'
import { Alert, Box, Button, MenuItem, Stack, TextField, Typography } from '@mui/material'
import apiClient from '../../utils/apiClient'
import organizationSessionStore from '../../stores/organizationSessionStore'

const TYPES = ['TEXT', 'INTEGER', 'DECIMAL', 'BOOLEAN', 'SINGLE_SELECT']

export default function CustomFieldDefinitionSettings() {
	const [definitions, setDefinitions] = useState([])
	const [label, setLabel] = useState('')
	const [type, setType] = useState('TEXT')
	const [options, setOptions] = useState('')
	const [error, setError] = useState(null)
	const canManage = ['OWNER', 'ADMIN'].includes(organizationSessionStore.currentContext?.membership?.role)
	const load = async () => {
		try { setDefinitions((await apiClient.get('/api/custom-field-definitions', { params: { includeArchived: true } })).data.definitions) } catch (cause) { setError(cause?.response?.data?.error?.code || 'CUSTOM_FIELDS_LOAD_FAILED') }
	}
	useEffect(() => { load() }, [organizationSessionStore.contextGeneration])
	const create = async () => {
		try {
			await apiClient.post('/api/custom-field-definitions', { label, type, options: type === 'SINGLE_SELECT' ? options.split('\n').map(item => item.trim()).filter(Boolean) : [] })
			setLabel(''); setOptions(''); await load()
		} catch (cause) { setError(cause?.response?.data?.error?.code || 'CUSTOM_FIELD_CREATE_FAILED') }
	}
	const rename = async definition => {
		const next = window.prompt('Название поля', definition.label)
		if (!next || next === definition.label) return
		try { await apiClient.patch(`/api/custom-field-definitions/${definition.id}`, { label: next }); await load() } catch (cause) { setError(cause?.response?.data?.error?.code || 'CUSTOM_FIELD_RENAME_FAILED') }
	}
	const archive = async definition => {
		try { await apiClient.post(`/api/custom-field-definitions/${definition.id}/archive`); await load() } catch (cause) { setError(cause?.response?.data?.error?.code || 'CUSTOM_FIELD_ARCHIVE_FAILED') }
	}
	return <Box sx={{ p: 2, maxWidth: 720 }}>
		<Typography variant="h6">Пользовательские поля объектов</Typography>
		<Typography variant="body2" sx={{ mb: 2 }}>Тип фиксируется после создания. Поля доступны только текущей организации.</Typography>
		{error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
		{canManage && <Stack spacing={1} sx={{ mb: 3 }}>
			<TextField label="Название" value={label} onChange={event => setLabel(event.target.value)} />
			<TextField select label="Тип" value={type} onChange={event => setType(event.target.value)}>{TYPES.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}</TextField>
			{type === 'SINGLE_SELECT' && <TextField label="Варианты (по одному в строке)" multiline minRows={3} value={options} onChange={event => setOptions(event.target.value)} />}
			<Button variant="contained" onClick={create} disabled={!label.trim()}>Создать поле</Button>
		</Stack>}
		<Stack spacing={1}>{definitions.map(definition => <Box key={definition.id} sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 1, opacity: definition.archivedAt ? .6 : 1 }}>
			<Typography>{definition.label} · {definition.type}{definition.archivedAt ? ' · архив' : ''}</Typography>
			{definition.type === 'SINGLE_SELECT' && <Typography variant="caption">{definition.options.map(option => option.label).join(', ')}</Typography>}
			{canManage && !definition.archivedAt && <Stack direction="row" spacing={1} sx={{ mt: 1 }}><Button size="small" onClick={() => rename(definition)}>Переименовать</Button><Button size="small" color="warning" onClick={() => archive(definition)}>Архивировать</Button></Stack>}
		</Box>)}</Stack>
	</Box>
}
